import { observer } from "mobx-react-lite"

const SingleTHeader = ({ value }) => {
    return (
        <th>{ value }</th>
    );
}

export default observer(SingleTHeader);